/**
 * @class EntityDropdownButton
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DropdownToggle, DropdownItem, DropdownMenu, ButtonDropdown } from 'reactstrap';
import { kebabCase } from 'lodash';
import Icon from '../containers/icon';
class EntityDropdownButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };
    this.toggle = this.toggle.bind(this);
  }
  componentDidMount() {
    const {
      indexQuery,
      list,
      serverIndex
    } = this.props;
    if (list.length === 0) {
      serverIndex(indexQuery);
    }
  }
  toggle() {
    const {
      isOpen
    } = this.state;
    this.setState({
      isOpen: !isOpen
    });
  }
  render() {
    const {
      list,
      title,
      enforceUniqueNames,
      names,
      enforceUnique,
      values,
      includeOther,
      entity,
      onAdd
    } = this.props;
    const {
      isOpen
    } = this.state;
    const titleWithIcon = /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Icon, {
      glyph: "plus"
    }), " ", title);
    let items;
    if (enforceUniqueNames) {
      items = list.filter(item => names.indexOf(item.name) === -1);
    } else if (enforceUnique) {
      items = list.filter(item => values.indexOf(item.id) === -1);
    } else {
      items = list;
    }

    // move dropdown button / menu item code into a dumb component
    const menuItems = items.map(item => /*#__PURE__*/React.createElement(DropdownItem, {
      className: `t-ed-menu-item-phase-code-${kebabCase(item.name)}`,
      key: item.id,
      onClick: () => onAdd(item)
    }, item.name));
    const other = includeOther ? /*#__PURE__*/React.createElement(DropdownItem, {
      key: "Other",
      className: "t-ed-menu-item-phase-code-other",
      onClick: () => onAdd('Other')
    }, "Other") : null;
    return /*#__PURE__*/React.createElement(ButtonDropdown, {
      isOpen: isOpen,
      style: {
        width: '100%'
      },
      toggle: this.toggle
    }, /*#__PURE__*/React.createElement(DropdownToggle, {
      size: "sm",
      caret: true,
      className: `pull-right entityDropdown t-ed-${kebabCase(entity)}`,
      disabled: !list.length && !includeOther,
      id: `${entity}dropDown`
    }, titleWithIcon), /*#__PURE__*/React.createElement(DropdownMenu, null, menuItems, other));
  }
}
EntityDropdownButton.defaultProps = {
  enforceUnique: true,
  enforceUniqueNames: false,
  includeOther: false,
  names: [],
  values: []
};
EntityDropdownButton.propTypes = {
  entity: PropTypes.string.isRequired,
  indexQuery: PropTypes.shape({
    filters: PropTypes.shape({})
  }).isRequired,
  list: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  serverIndex: PropTypes.func.isRequired,
  enforceUnique: PropTypes.bool,
  enforceUniqueNames: PropTypes.bool,
  includeOther: PropTypes.bool,
  names: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string.isRequired,
  values: PropTypes.arrayOf(PropTypes.string),
  onAdd: PropTypes.func.isRequired
};
export default EntityDropdownButton;